export default "__VITE_ASSET__DMHnxIFc__"